export default __webpack_public_path__ + "assets/img/avatar-6.5081637.png";